import { render } from "./sys-dict-data.vue?vue&type=template&id=0be5434a"
import script from "./sys-dict-data.vue?vue&type=script&lang=js"
export * from "./sys-dict-data.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__